import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-inbox",

  templateUrl: "./inbox.component.html",
  styleUrl: "./inbox.component.css",
  standalone: false,
})
export class InboxComponent {
  selectedTabIndex = 0;
  filingId = 0;
  filingState = "";
  constructor(_route: ActivatedRoute) {
    _route.queryParams.subscribe((params) => {
      this.filingId = params["filingId"];
      this.filingState = params["filingState"];
      if (this.filingId) {
        this.selectedTabIndex =
          this.filingState == "UNPROCESSED" || this.filingState == "TBD"
            ? 1
            : this.filingState == "PROCESSED" || this.filingState == "DUPLICATE"
            ? 2
            : 0;
      }
    });
  }
}
